import React, { Component, useEffect, useLayoutEffect, useState } from "react";
import Viewers from "react-images-viewer";
import i18n from "../../../../../constants/initLng";
import "./ImageViewer.less";

const ImageViewer = (props) => {
  //! State
  const { isOpen, isPreview3x3 } = props;
  useLayoutEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const imgSelector = document.querySelector(
          // '#viewerBackdrop figure img[class*="imgLoaded"]'
          '#viewerBackdrop figure img'
        );

        if (imgSelector) {
          if (isPreview3x3) {
            imgSelector.classList.add("image-3x3");
          }

          imgSelector.setAttribute("style", "opacity: 1 !important");
        }
      }, 0);
    }

    return () => {};
  }, [isOpen, isPreview3x3]);

  return (
    <Viewers
      {...props}
      closeBtnTitle={props.closeBtnTitle || i18n.t(`action.exit`)}
    />
  );
};

export default ImageViewer;
